var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Select", {
    staticClass: "component--select_search",
    attrs: {
      name: _vm.name,
      placeholder: _vm.placeholder,
      empty: _vm.empty,
      multiple: _vm.multiple,
      items: _vm.searchedItems,
      active: _vm.active,
      activeLabel: _vm._activeLabel,
      unfocusByHandler: false,
    },
    on: {
      "dropdown-focus": _vm.changeFocus,
      selectChange: _vm.selectChange,
      select: (value) => _vm.$emit("select", value),
    },
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function () {
            return [
              !_vm.isShowInput
                ? _c(
                    "div",
                    {
                      staticClass:
                        "placeholder placeholder_inline placeholder_icon",
                      on: { click: _vm.onClickTitle },
                    },
                    [
                      !_vm.isDisabled
                        ? _c("Icon", { attrs: { id: "arrow-down" } })
                        : _vm._e(),
                      _vm._v(
                        "\n\n            " +
                          _vm._s(_vm._activeLabel || _vm.placeholder) +
                          "\n        "
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.onClickOutside,
                          expression: "onClickOutside",
                        },
                      ],
                      staticClass:
                        "placeholder placeholder_input placeholder_icon",
                      staticStyle: { "--icons-offset": "50px" },
                    },
                    [
                      _c("input", {
                        directives: [{ name: "focus", rawName: "v-focus" }],
                        attrs: { type: "text" },
                        domProps: { value: _vm._searchText },
                        on: {
                          input: (e) => _vm.setSearch(e.target.value),
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.$emit("enter")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._searchText
                        ? _c("Icon", {
                            attrs: { id: "delete", color: "purple" },
                            on: { click: _vm.resetSearch },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("Icon", { attrs: { id: "lens" } }),
                    ],
                    1
                  ),
            ]
          },
          proxy: true,
        },
        {
          key: "actions",
          fn: function () {
            return [_vm._t("actions")]
          },
          proxy: true,
        },
        {
          key: "empty",
          fn: function () {
            return [_vm._t("empty")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }